'use client';

import React from 'react';
import Link from 'next/link';
import SiteHeader from '@/components/SiteHeader';
import SiteFooter from '@/components/SiteFooter';
import { ArrowLeft, Home } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen" style={{ background: '#07060C' }}>
      <SiteHeader theme="transparent" />
      <main className="flex flex-col items-center justify-center min-h-screen px-6 text-center">
        <div
          className="font-display font-extrabold text-[120px] sm:text-[160px] leading-none tracking-tight select-none"
          style={{
            backgroundImage: 'linear-gradient(135deg, rgba(255,61,245,0.25) 0%, rgba(122,92,255,0.20) 50%, rgba(76,201,255,0.25) 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          404
        </div>
        <h1 className="font-display font-bold text-[28px] sm:text-[36px] mb-4 -mt-4" style={{ color: '#F2F4FF' }}>
          Page not found.
        </h1>
        <p className="text-[16px] leading-relaxed max-w-md mb-10" style={{ color: 'rgba(167,163,196,0.70)' }}>
          The page you're looking for doesn't exist or has moved. Let's get you back to Panorama.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link href="/" className="btn-primary group inline-flex items-center gap-2">
            <Home size={15} />
            Back to Homepage
          </Link>
          <button
            onClick={() => window.history?.back()}
            className="btn-secondary inline-flex items-center gap-2"
          >
            <ArrowLeft size={15} />
            Go Back
          </button>
        </div>
        <div
          className="mt-14 pt-8 border-t w-full max-w-md"
          style={{ borderColor: 'rgba(255,255,255,0.06)' }}
        >
          <p className="text-[11px] font-semibold tracking-[0.10em] uppercase mb-4" style={{ color: 'rgba(167,163,196,0.35)' }}>
            Explore Panorama
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link href="/why-panorama" className="text-[13px] font-medium px-4 py-2 rounded-lg transition-all duration-150 hover:bg-white/[0.06]" style={{ color: '#A7A3C4', border: '1px solid rgba(255,255,255,0.08)' }}>
              Why Panorama
            </Link>
            <Link href="/amenities" className="text-[13px] font-medium px-4 py-2 rounded-lg transition-all duration-150 hover:bg-white/[0.06]" style={{ color: '#A7A3C4', border: '1px solid rgba(255,255,255,0.08)' }}>
              Amenities
            </Link>
            <Link href="/community" className="text-[13px] font-medium px-4 py-2 rounded-lg transition-all duration-150 hover:bg-white/[0.06]" style={{ color: '#A7A3C4', border: '1px solid rgba(255,255,255,0.08)' }}>
              Community
            </Link>
            <Link href="/request-access" className="text-[13px] font-medium px-4 py-2 rounded-lg transition-all duration-150 hover:bg-white/[0.06]" style={{ color: '#A7A3C4', border: '1px solid rgba(255,255,255,0.08)' }}>
              Request Access
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}